import React from "react";
import * as LucideIcons from "lucide-react";

export default function FeatureCardGrid({ features = [] }) {
  if (!features || features.length === 0) return null;

  return (
    <div className="w-full py-20 relative overflow-hidden" style={{ background: "#0B0B14" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Section header */}
        <div className="mb-16">
          <div className="flex items-center gap-2 mb-6">
            <div style={{ height: 1, width: 32, background: "linear-gradient(90deg, #F97316, #8B5CF6)" }} />
            <p
              className="text-xs tracking-widest uppercase"
              style={{
                background: "linear-gradient(135deg, #F97316, #A78BFA)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Key Features
            </p>
          </div>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => {
            // Get the icon component from lucide-react
            const IconComponent = LucideIcons[feature.icon];

            return (
              <div
                key={i}
                style={{
                  padding: "2rem",
                  borderRadius: 16,
                  background: "rgba(255,255,255,0.02)",
                  border: "1px solid rgba(255,255,255,0.06)",
                  height: "100%",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "rgba(249,115,22,0.4)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.04)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.02)";
                }}
              >
                {IconComponent && (
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      background: "rgba(249,115,22,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "1.25rem",
                    }}
                  >
                    <IconComponent size={24} style={{ color: "#F97316" }} />
                  </div>
                )}
                <h3
                  className="font-display font-semibold mb-2"
                  style={{ fontSize: "1.15rem", color: "#F5F5F5" }}
                >
                  {feature.title}
                </h3>
                <p
                  className="font-light"
                  style={{
                    fontSize: "0.9rem",
                    color: "rgba(245,245,245,0.5)",
                    lineHeight: 1.6,
                  }}
                >
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
